import { render, staticRenderFns } from "./HomeClassic.vue?vue&type=template&id=24621497&scoped=true"
import script from "./HomeClassic.vue?vue&type=script&lang=js"
export * from "./HomeClassic.vue?vue&type=script&lang=js"
import style0 from "./HomeClassic.vue?vue&type=style&index=0&id=24621497&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24621497",
  null
  
)

export default component.exports